import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';
import { ActivatedRoute } from "@angular/router";
import { environment } from '../../../environments/environment';
import { ISubGroupQuestion } from '../tax-return-builder/tax-return-builder';
import { cloneDeep } from "lodash-es";
import { SmartFormLogicService, SyncSmartFormTypeToOneTeam200Response, FullSmartFormType, FullSmartFormCategory, FullSmartFormQuestion, FullSmartFormSubCategory, SmartFormLogic, SmartFormTypeService, SyncWithOneteamResponseErrorMessagesInner, TaxReturnService } from '../../../../swaggerServices';
import { TRANSLOCO_SCOPE, TranslocoService } from '@jsverse/transloco';
import { ConfigStateService } from '../../config/config-state.service';
import { UserInfoService } from '../../user-info.service';

declare var $: any;

@Component({
    selector: 'app-smart-form-builder',
    templateUrl: './smart-form-builder.component.html',
    styleUrls: ['./smart-form-builder.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: { scope: 'smart-forms', alias: 'smartForms' }
        }
    ],
    standalone: false
})
export class SmartFormBuilderComponent implements OnInit, OnDestroy {
  @ViewChild('newCategoryModal', { static: true }) newCategoryModal: ElementRef;
  @ViewChild('newSubCategoryModal', { static: true }) newSubCategoryModal: ElementRef;
  @ViewChild('editModal', { static: true }) editModal: ElementRef;
  @ViewChild('confirmDeleteModal', { static: true }) confirmDeleteModal: ElementRef;
  @ViewChild('editLogicModal', { static: true }) editLogicModal: ElementRef;
  @ViewChild('oneteamSyncModal') oneteamSyncModal: ElementRef;
  @ViewChildren('categoryPopup') categoryPopups: QueryList<ElementRef>;
  @ViewChildren('subCategoryPopup') subCategoryPopups: QueryList<ElementRef>;
  @ViewChildren('questionPopup') questionPopups: QueryList<ElementRef>;
  @ViewChildren('rootNodePopup') rootNodeElements: QueryList<ElementRef>;
  @ViewChild("msgModal") msgModal: ElementRef;

  updateDragEvent = new EventEmitter();
  isSaving = false;
  isLoading = false;
  isReady: boolean;
  isSyncingCache: boolean;
  activeTab: 'questions' | 'conditional logic' = "questions";
  showQuestionId = true;
  draggingQuestion = false;
  originalQuestions: ISubGroupQuestion[] = [];
  questions: ISubGroupQuestion[] = [];
  questionsInUse: ISubGroupQuestion[] = [];
  oneteamSyncResponse: SyncSmartFormTypeToOneTeam200Response = {success: false, message: "", errorMessages:[]};
  syncingWithOneTeam = false;
  lang: string

  questionSearch = '';
  upsertedItem = {
    name: "",
    categoryIndex: "",
    subCategoryIndex: "",
  };
  openModal: undefined | "logic" | "category" | "subCategory" | "edit" | "delete";

  editedLogic = {
    id: null,
    parentNode: {},
    childNodes: [],
  };

  rootLogicNodes: SmartFormLogic[] = [];
  deletedLogicNodes = [];

  deletingType: "question" | "subCategory" | "category";
  deletingIndexes;

  originalSmartFormData: FullSmartFormType;

  categories: (FullSmartFormCategory & { collapsed: boolean})[] = []

  draggingSubCategory = null;
  isProductionMode: boolean;
  taxYear: number;
  smartFormTypeId: number;
  rootNodeBeingEdited = null;
  deletionErrorMessage = null
  lockStatus: boolean;

  draggingData: any

  private subscriptions: Subscription[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private smartFormService: SmartFormTypeService,
    private taxReturnService: TaxReturnService,
    private smartFormLogicService: SmartFormLogicService,
    public config: ConfigStateService,
    private userInfo: UserInfoService,
    private translocoService: TranslocoService,
  ) {
    this.isProductionMode = environment.production;
    this.translocoService.langChanges$.subscribe(l => this.lang = l);
  }

  ngAfterViewInit() {
    $(this.editLogicModal.nativeElement).modal({
      onShow: () => this.openModal = 'logic',
      onHidden: () => this.openModal = undefined
    });
    $(this.newCategoryModal.nativeElement).modal({
      onShow: () => this.openModal = 'category',
      onHidden: () => this.openModal = undefined
    });
    $(this.newSubCategoryModal.nativeElement).modal({
      onShow: () => this.openModal = 'subCategory',
      onHidden: () => this.openModal = undefined
    });
    $(this.editModal.nativeElement).modal({
      onShow: () => this.openModal = 'edit',
      onHidden: () => this.openModal = undefined
    });
    $(this.confirmDeleteModal.nativeElement).modal({
      onShow: () => this.openModal = 'delete',
      onHidden: () => this.openModal = undefined
    });
    $(this.msgModal.nativeElement).modal({
      onHidden: () => this.deletionErrorMessage = null
    });
  }

  stopPropagation(event: Event) {
    event.stopPropagation();
  }

  getRootConditionById(id) {
    for (let i = 0; i < this.rootLogicNodes.length; i++) {
      const node = this.rootLogicNodes[i] as any;
      if(node.id == id) {
        return node;
      }
    }
    return undefined;
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach(val => {
      val.unsubscribe();
    })
  }

  ngOnInit() {
    this.isLoading = true;
    this.subscriptions.push(this.activatedRoute.queryParams.subscribe( params => {
      this.taxYear = params['taxYear'];
      this.smartFormTypeId = params['smartFormTypeId'];
      this.loadSmartFormData(this.taxYear, this.smartFormTypeId);
    }));
    this.isReady = true;
  };

  getTaxYearParam() {
    return { taxYear: this.taxYear };
  }

  swapItemsInList(list, index1, index2) {
    if (!list || !list[index1] || !list[index2])
      return;

    const temp = list[index1];
    list[index1] = list[index2];
    list[index2] = temp;

  }


  generateDragData(question, isMovingExistingQuestion, category?) {
    return {...question, isMovingExistingQuestion, category}
  }

  collapseAll() {
    this.categories.forEach(c => c.collapsed = true)
  }

  expandAll() {
    this.categories.forEach(c => c.collapsed = false)
  }

  countUsedQuestions() {
    return this.categories.reduce((count, category) => {
      return count + this.countQuestionsInCategory(category);
    }, 0,);
  }

  countQuestionsInCategory(category) {
    return category.smartFormSubCategories.reduce((count, subCategory) => {
      return count + this.countQuestionsInSubCategory(subCategory);
    }, 0,);
  }

  countQuestionsInSubCategory(subCategory) {
    return subCategory?.smartFormQuestions?.length ?? 0
  }

  addQuestion(q, subCategory) {
    if (!q?.isMovingExistingQuestion) {
      if (!subCategory?.smartFormQuestions || !q?.id)
      {
        return;
      }
      let newSmartFormQuestion = cloneDeep(q);
      newSmartFormQuestion.id = undefined;
      newSmartFormQuestion.questionId = q.id;
      newSmartFormQuestion.children = q.children;
      newSmartFormQuestion.smartFormSubCategoryId = subCategory.id

      subCategory.smartFormQuestions.push(newSmartFormQuestion);
      this.questionsInUse.push(q)

      this.questions.splice(this.questions.findIndex(question => question.id == q.id), 1);

      if (this.questionSearch  ?.length) {
        this.questions = [...this.questions]; // This is required to update questions
      }
    }else {
      let newSmartFormQuestion = cloneDeep(q);
      if (subCategory.id !== q?.smartFormSubCategoryId) {
        this.categories.map(category => {
          category?.smartFormSubCategories.map(subCat => {
            if (subCat.id === q?.smartFormSubCategoryId) {
              subCat?.smartFormQuestions.splice(subCat?.smartFormQuestions.findIndex(question => question.questionId == q.questionId), 1)
            }
            if (subCat.id === subCategory.id) {
              subCat?.smartFormQuestions.push(newSmartFormQuestion);
            }
            subCat?.smartFormQuestions.map((question: any, index) => {
              if (question.questionId === q?.questionId) {
                question.oldSmartFormSubCategoryId = question.smartFormSubCategoryId
                question.smartFormSubCategoryId = subCategory.id
                question.order = index + 1
              }
            })
          })
        })
      }

    }

  }

  onDragStart(question, isMovingExistingQuestion, category?){
    this.draggingData = {...question, isMovingExistingQuestion, category}
  }

  isDropAllowed(subCategory) {
    if (this.draggingData?.isMovingExistingQuestion) {
      return subCategory.smartFormCategoryId === this.draggingData?.category?.id ? 'question' : 'not-allowed';
    }
    return 'question';
  }

  /** If "logicNode" = null, it will iterate over all logic nodes */
  checkIfQuestionExistsAsLogicCondition(questionId, logicNode = null) {
    const evaluateList = (logicNodes) => {
      for (let index = 0; index < logicNodes.length; index++) {
        if (this.checkIfQuestionExistsAsLogicCondition(questionId, logicNodes[index])) {
          return true;
        }
      }
      return false;
    }

    if (!logicNode) {
      return evaluateList(this.rootLogicNodes);
    }

    let result = logicNode.questionId === questionId;

    if (!result && logicNode.andChildren?.length) {
      result = evaluateList(logicNode.andChildren)
    }
    if (!result && logicNode.orChildren?.length) {
      result = evaluateList(logicNode.orChildren)
    }
    return result;
  }

  sortQuestions() {
    this.questions = [...this.questions.sort((a, b) => a.id > b.id ? 1 : -1)]
  }

  removeQuestion(q, subCategory) {
    if (!q || !subCategory?.smartFormQuestions?.length) {
      throw Error("Bad data when trying to remove a question")
    }
    else if(this.checkIfQuestionExistsAsLogicCondition(q.questionId)) {
      throw Error(`
      Question Id "${q.questionId}" cannot be deleted as it is a condition in a smart form logic block.
      You must remove the question from the condition before deleting it from the smart form builder.
      `)
    }
    else if (q.conditionIds?.length) {
      throw Error(`
      Question Id "${q.questionId}" cannot be deleted as it is referenced in the actions of a smart form logic block.
      You must remove the question from the actions before deleting it from the smart form builder.
      `)
    }

    const questionIndex = subCategory.smartFormQuestions.findIndex(val => val.questionId === q.questionId)

    if (questionIndex == -1) {
      throw Error(`Question of Id "${q.questionId}" cannot be deleted as it isn't referenced by a smartFormQuestion on category of Id "${subCategory.id}".`
      )
    }

    const deletingIndex = this.questionsInUse.findIndex(val => val.id === q.questionId);
    // Remove question from smartForm and add it back into the smartFormList
    this.questions.push(...this.questionsInUse.splice(deletingIndex, 1));
    subCategory.smartFormQuestions.splice(questionIndex, 1);
  }

  onClickEditCategory(category, categoryIndex) {
    this.upsertedItem.name = category.name;
    this.upsertedItem.categoryIndex = categoryIndex;
    $(this.editModal.nativeElement).modal('show');
  }

  showDeleteModal(type, indexes){
    this.deletingType = type;
    this.deletingIndexes = indexes;

    this.upsertedItem.name = "";
    $(this.confirmDeleteModal.nativeElement).modal('show');
  }

  showDeletionErrorMsgModal(message) {
    this.deletionErrorMessage = message
    $(this.msgModal.nativeElement).modal("show");
  }

  deleteItem() {
    this.deletionErrorMessage = null
    try {
      switch (this.deletingType) {
        case "category": {
          let [index] = this.deletingIndexes;
          const category = (this.categories[index] as any);
          if(category.conditionIds?.length) {
            throw Error(`
            Category of Id "${category.id}" cannot be deleted as it is referenced in the conditions of a smart form logic block.
            You must remove the category from the condition before deleting it from the smart form builder.`)
          }
          category.smartFormSubCategories?.forEach(subCategory => {
            while (subCategory.smartFormQuestions.length) {
              const question = subCategory.smartFormQuestions[0];
              this.removeQuestion(question, subCategory);
            }
          });
          this.categories.splice(index, 1);
          this.sortQuestions();
          break;
        }
        case "subCategory": {
          let [categoryIndex, subCategoryIndex] = this.deletingIndexes;
          const subCategory = (this.categories[categoryIndex].smartFormSubCategories[subCategoryIndex] as any)
          if(subCategory.conditionIds?.length) {
            throw Error(`
            SubCategory of Id "${subCategory.id}" cannot be deleted as it is referenced in the conditions of a smart form logic block.
            You must remove the subCategory from the condition before deleting it from the smart form builder.`
            )
          }
          while (subCategory.smartFormQuestions.length) {
            const question = subCategory.smartFormQuestions[0];
            this.removeQuestion(question, subCategory);
          }
          this.categories[categoryIndex].smartFormSubCategories.splice(subCategoryIndex, 1);
          this.sortQuestions();
          break;
        }
        case "question": {
          let [categoryIndex, subCategoryIndex, questionIndex] = this.deletingIndexes;
          const question = this.categories[categoryIndex].smartFormSubCategories[subCategoryIndex].smartFormQuestions[questionIndex];
          this.removeQuestion(question, this.categories[categoryIndex].smartFormSubCategories[subCategoryIndex])
          this.sortQuestions();
          break;
        }
        default: {
          break;
        }
      }

      $(this.confirmDeleteModal.nativeElement).modal('hide');
    }catch (e) {
      $(this.confirmDeleteModal.nativeElement).modal('hide');
      this.showDeletionErrorMsgModal(e.message)
    }

  }

  onClickEditSubCategory(subCategory, categoryIndex, subCategoryIndex) {
    this.upsertedItem.name = subCategory.name;
    this.upsertedItem.categoryIndex = categoryIndex;
    this.upsertedItem.subCategoryIndex = subCategoryIndex;
    $(this.editModal.nativeElement).modal('show');
  }

  OpenConditionalLogic(rootNode) {
    this.rootNodeBeingEdited = rootNode;
    $(this.editLogicModal.nativeElement).modal('show');
  }

  getSmartFormQuestionByQuestionId(id) {
    for (let i = 0; i < this.categories.length; i++) {
      const category = this.categories[i];
      for (let j = 0; j < category.smartFormSubCategories.length; j++) {
        const subCategory = category.smartFormSubCategories[j];
        for (let k = 0; k < subCategory.smartFormQuestions.length; k++) {
          const question = subCategory.smartFormQuestions[k];
          if (question.questionId == id) {
            return question as FullSmartFormQuestion & { conditionIds: number[] };
          }
        }
      }
    }
    return null;
  }

  removeActionsFromFormMetaData(rootNode: SmartFormLogic) {
    let removalId = null;
    let removalIndex = -1;
    for (let i = 0; i < this.categories.length; i++) {
      const category = this.categories[i] as any;
      removalId = rootNode.actions.find(val => val.entity == 'smartFormCategory' && val.entityId == category.id) ? rootNode.id : null;
      if (removalId) {
        removalIndex = category.conditionIds?.findIndex(val => val == removalId) ?? -1;
        category.conditionIds.splice(removalIndex,1);
      }
      for (let j = 0; j < category.smartFormSubCategories.length; j++) {
        const subCategory = category.smartFormSubCategories[j] as FullSmartFormSubCategory & { conditionIds: number[] };
        removalId = rootNode.actions.find(val => val.entity == 'smartFormSubCategory' && val.entityId == subCategory.id) ? rootNode.id : null;
        if (removalId) {
          removalIndex = subCategory.conditionIds?.findIndex(val => val == removalId) ?? -1;
          subCategory.conditionIds.splice(removalIndex,1);
        }
        for (let k = 0; k < subCategory.smartFormQuestions.length; k++) {
          const question = subCategory.smartFormQuestions[k] as FullSmartFormQuestion & { conditionIds: number[] };
          removalId = rootNode.actions.find(val => val.entity == 'question' && val.entityId == question.questionId) ? rootNode.id : null;
          if (removalId) {
            removalIndex = question.conditionIds?.findIndex(val => val == removalId) ?? -1;
            question.conditionIds.splice(removalIndex,1);
          }
        }
      }
    }
  }

  addActionsToFormMetaData(rootNode: SmartFormLogic) {
    for (let i = 0; i < this.categories.length; i++) {
      const category = this.categories[i] as any;
      if (rootNode.actions.find(val => val.entity == 'smartFormCategory' && val.entityId == category.id)) {
        if (!category.conditionIds) {
          category.conditionIds = [rootNode.id];
        }
        else {
          category.conditionIds?.push(rootNode.id);
        }
      }
      for (let j = 0; j < category.smartFormSubCategories.length; j++) {
        const subCategory = category.smartFormSubCategories[j] //as FullSmartFormTypeSmartFormSubCategories & { conditionIds: number[] };
        if (rootNode.actions.find(val => val.entity == 'smartFormSubCategory' && val.entityId == subCategory.id)) {
          if (!subCategory.conditionIds) {
            subCategory.conditionIds = [rootNode.id];
          }
          else {
            subCategory.conditionIds?.push(rootNode.id);
          }
        }
        for (let k = 0; k < subCategory.smartFormQuestions.length; k++) {
          const question = subCategory.smartFormQuestions[k] //as FullSmartFormTypeSmartFormQuestions & { conditionIds: number[] };
          if (rootNode.actions.find(val => val.entity == 'question' && val.entityId == question.questionId)) {
            if (!question.conditionIds) {
              question.conditionIds = [rootNode.id];
            }
            else {
              question.conditionIds?.push(rootNode.id);
            }
          }
        }
      }
    }
  }

  updateRootLogicNode(rootNode) {
    if (rootNode.localIndex === undefined) {
      rootNode.localIndex ??= this.rootLogicNodes.length;
      rootNode.id ??= -rootNode.localIndex - 1;
      this.addActionsToFormMetaData(rootNode)
      this.rootLogicNodes.push(rootNode);
    }
    else {
      const oldLogic = this.rootLogicNodes[rootNode.localIndex];
      if (!rootNode.id) {
        oldLogic.id = rootNode.id = -rootNode.localIndex - 1;
      }
      this.removeActionsFromFormMetaData(oldLogic)
      this.addActionsToFormMetaData(rootNode)
      this.rootLogicNodes[rootNode.localIndex] = rootNode;
    }
    $(this.editLogicModal.nativeElement).modal('hide');
  }

  hideLogicModal() {
    $(this.editLogicModal.nativeElement).modal('hide');
  }

  deleteRootLogicNode(node) {
    if (node.id) {
      this.deletedLogicNodes.push(node);
    }
    this.removeActionsFromFormMetaData(node);
    this.rootLogicNodes.splice(node.localIndex, 1);
    $(this.editLogicModal.nativeElement).modal('hide');

    for (let i = 0; i < this.rootLogicNodes.length; i++) {
      (this.rootLogicNodes[i] as any).localIndex = i;
    }
  }

  showCreateCategoryModal() {
    this.upsertedItem.name = "";
    $(this.newCategoryModal.nativeElement).modal('show');
  }

  updateItem() {
    if (this.upsertedItem.categoryIndex === '') {
      return;
    }
    if (this.upsertedItem.subCategoryIndex === '') {
      this.categories[this.upsertedItem.categoryIndex].name = this.upsertedItem.name;
    } else {
      this.categories[this.upsertedItem.categoryIndex].smartFormSubCategories[this.upsertedItem.subCategoryIndex].name = this.upsertedItem.name;
    }

    this.upsertedItem.name = '';
    this.upsertedItem.categoryIndex = '';
    this.upsertedItem.subCategoryIndex = '';
    $(this.editModal.nativeElement).modal('hide');
  }

  createCategory() {
    this.categories.push({
      collapsed: true,
      name: this.upsertedItem.name,
      year: this.taxYear,
      smartFormSubCategories: [{
        name: "default",
        smartFormQuestions: []
      }],
    })

    this.upsertedItem.name = "";
    $(this.newCategoryModal.nativeElement).modal('hide');
  }

  showCreateSubCategoryModal(categoryIndex){
    this.upsertedItem.name = "";
    this.upsertedItem.categoryIndex = categoryIndex;

    $(this.newSubCategoryModal.nativeElement).modal('show');
  }

  createSubCategory() {
    if (this.upsertedItem?.categoryIndex == null) {
      return;
    }
    this.categories[this.upsertedItem.categoryIndex].smartFormSubCategories.push({
      name: this.upsertedItem.name,
      smartFormQuestions: [],
    })

    this.upsertedItem.name = "";
    $(this.newSubCategoryModal.nativeElement).modal('hide');
  }

  canSyncToOneteam() {
    return this.userInfo.isAdmin && this.config.featureFlags.enableOneteamIntegration
  }

  syncToOneteam() {
    const payload = {
      smartFormTypeId: +this.smartFormTypeId,
      year: this.taxYear
    }
    this.syncingWithOneTeam = true;
    this.smartFormService.syncSmartFormTypeToOneTeam(payload).subscribe(
    data => {
      this.syncingWithOneTeam = false;
      if (data?.success) {
        this.oneteamSyncResponse.success = data?.success;
        this.oneteamSyncResponse.message = `Successfully synced smart form type with Collaborate.`;
      } else {
        this.oneteamSyncResponse.errorMessages = data?.errorMessages || [];
        if(data?.messageObject[this.lang]){
          this.oneteamSyncResponse.message = data?.messageObject[this.lang];
        } else {
          this.oneteamSyncResponse.message = data?.message
        }
      }
      $(this.oneteamSyncModal.nativeElement).modal("show");
    },
    err => {
      this.syncingWithOneTeam = false;
      if(err.error?.message?.length){
        this.oneteamSyncResponse.message = err?.error?.message || `Failed to sync smart form type with Collaborate.`;
        $(this.oneteamSyncModal.nativeElement).modal("show");
      }
    });
  }

  syncCache() {
    this.isSyncingCache = true;
    this.subscriptions.push(
      forkJoin([
        this.taxReturnService.syncTaxReturnStructure(),
        this.taxReturnService.syncGlobalStructure(),
      ]).subscribe(() => {
        this.isSyncingCache = false;
      })
    );
  }

  closeOneteamSyncModal(){
    this.oneteamSyncResponse.message = "";
    this.oneteamSyncResponse.errorMessages = [];
    $(this.oneteamSyncModal.nativeElement).modal("hide");
  }

  private loadSmartFormData(year, smartFormTypeId) {
    this.smartFormService.getFullSmartFormTypeData(smartFormTypeId, year).subscribe(result => {
      this.lockStatus = result?.smartFormData?.lock
      let questions: any[] = result.questions;
      let categories = result.smartFormData.smartFormCategories;

      // assemble table questions
      for (let i = 0; i < questions.length; i++) {
        if (!questions[i].parentId) {
          continue;
        }
        const parent = questions.find(val => val.id === questions[i].parentId);

        if (!parent) {
          continue;
        }
        else if (parent.displayFieldType !== "table") { // Remove tab questions and other similar ones that aren't a table
          questions.splice(i--, 1);
          const parentIndex = questions.indexOf(questions);
          if (parentIndex != -1) {
            questions.splice(parentIndex)
            if (parentIndex < i) {
              i--;
            }
          }
          continue;
        }

        if(!parent.children) {
          parent.children = []
        }

        parent.children.push(questions[i]);

        questions.splice(i--, 1);
      }

      /** larger or null order gets sorted to go last */
      function sortByOrder(a, b) {
        if (!a.order) {
          return 1;
        }
        if (!b.order) {
          return -1;
        }
        return a.order < b.order ? -1 : 1
      }

      categories?.sort(sortByOrder)

      categories?.forEach(category => {
        category.smartFormSubCategories.sort(sortByOrder);
        // as any so typescript is happy
        (category as any).collapsed = true;
        (category as any).hoverConditions = false;

        category.smartFormSubCategories?.forEach(subCategory => {
          subCategory.smartFormQuestions.sort(sortByOrder)

          subCategory.smartFormQuestions?.forEach((q: any) => {
            const originalQuestion = questions.find(q2 => q2.id === q.questionId);
            if(!originalQuestion) {
              const existingQuestion = this.questionsInUse.find(val => val.id === q.questionId);
              if (existingQuestion) {
                console.log(`smartFormQuestion of questionId "${q.questionId}" is included in this smartform twice`, q);
                console.log(`the other smartFormQuestion of questionId "${q.questionId}" is:`, existingQuestion);
              }
              else {
                console.log(`question of Id "${q.questionId}" isn't in the taxReturnType questions for this year, but is referenced in the smartFormQuestion:`, q);
              }
            }
            else {
              q.question = originalQuestion.question;
              q.children = originalQuestion.children;
              q.questionId = originalQuestion.id;
              q.category = originalQuestion.category;
              q.displayFieldType = originalQuestion.displayFieldType;
              q.children = originalQuestion.children;

              this.questionsInUse.push(originalQuestion);
              questions.splice(questions.indexOf(originalQuestion), 1);
            }
          });
        });
      });


      this.questions = questions;
      this.categories = categories as any;
      this.originalSmartFormData = { smartFormCategories: cloneDeep(categories), name: result.smartFormData.name };
      //this.rootLogicNodes = result.smartFormLogic;
      this.rootLogicNodes = [];
      result.smartFormLogic.forEach(logic => {
        this.updateRootLogicNode(logic); // this should also set up all the meta data
      })
      this.isReady = true;
      this.isLoading = false;
    });
  }

  private saveSmartFormDataToDatabase() {
    if (this.isSaving) {
      return;
    }
    const updatedSmartForm = {
      id: this.smartFormTypeId,
      name: this.originalSmartFormData.name,
      smartFormCategories: []
    }

    const deletedItems = {
      categories: [],
      subCategories: [],
      questions: [],
    }

    const createdItems = {
      categories: [],
      subCategories: [],
      questions: [],
    }

    // get all edited and deleted items
    this.originalSmartFormData.smartFormCategories.forEach((category, i) => {
      if (category.id == undefined) {
        return;
      }
      let changes = false;
      let updatedCategory: any = { id: category.id, year: category.year, smartFormSubCategories: []}
      const editedCategoryIndex = this.categories.findIndex(c => c.id === category.id && c.id != undefined);
      const editedCategory = this.categories[editedCategoryIndex];
      if (!editedCategory) {
        deletedItems.categories.push(updatedCategory);
        return;
      }

      category.smartFormSubCategories.forEach((subCategory, j) => {
        if (subCategory.id == undefined) {
          return;
        }
        let updatedSubCategory: any = { id: subCategory.id, smartFormQuestions: [] };
        const editedSubCategoryIndex = editedCategory.smartFormSubCategories.findIndex(c => c.id === subCategory.id && c.id != undefined);
        const editedSubCategory = editedCategory.smartFormSubCategories[editedSubCategoryIndex];
        if (!editedSubCategory) {
          deletedItems.subCategories.push(updatedSubCategory);
          return;
        }

        subCategory.smartFormQuestions.forEach((question, k) => {
          if (question.id == null) {
            return;
          }
          let updatedQuestion: any = { id: question.id };
          const editedQuestionIndex = editedSubCategory.smartFormQuestions.findIndex(c => c.id === question.id && c.id != undefined);
          const editedQuestion = editedSubCategory.smartFormQuestions[editedQuestionIndex];
          if (!editedQuestion) {
            deletedItems.questions.push(updatedQuestion);
            return;
          }

          if (question.showByDefault != editedQuestion.showByDefault) {
            changes = true;
            updatedQuestion.showByDefault = editedQuestion.showByDefault;
          }

          if (question.hideForPreparer != editedQuestion.hideForPreparer) {
            changes = true;
            updatedQuestion.hideForPreparer = editedQuestion.hideForPreparer;
          }

          if (question.triggerSyncInOneTeam != editedQuestion.triggerSyncInOneTeam) {
            changes = true;
            updatedQuestion.triggerSyncInOneTeam = editedQuestion.triggerSyncInOneTeam;
          }

          if (question.id != editedSubCategory.smartFormQuestions[k]?.id) {
            changes = true;
            updatedQuestion.order = editedQuestionIndex + 1;
          }

          if (changes) {
            updatedSubCategory.smartFormQuestions.push(updatedQuestion)
          }
        });

        if (subCategory.id != editedCategory.smartFormSubCategories[j]?.id) {
          changes = true;
          updatedSubCategory.order = editedSubCategoryIndex + 1;
        }
        if (subCategory.name != editedSubCategory.name) {
          changes = true;
          updatedSubCategory.name = editedSubCategory.name;
        }

        if (changes) {
          updatedCategory.smartFormSubCategories.push(updatedSubCategory);
        }
      });



      if (category.id != this.categories[i]?.id) {
        changes = true;
        updatedCategory.order = editedCategoryIndex + 1;
      }
      if (category.name != editedCategory.name) {
        changes = true;
        updatedCategory.name = editedCategory.name;
      }
      if (updatedCategory.year == null) {
        changes = true;
        updatedCategory.year = this.taxYear;
      }

      if (changes) {
        updatedSmartForm.smartFormCategories.push(updatedCategory);
      }
    });

    const addQuestionAsUpdatedItem = (category, subCategory, question) => {
      let smartFormCategory = updatedSmartForm.smartFormCategories.find(c => c.id == category.id);
      if (!smartFormCategory) {
          // If the smartFormCategory doesn't exist, create it
          smartFormCategory = {
              id: category.id,
              year: category.year,
              smartFormSubCategories: []
          };
          updatedSmartForm.smartFormCategories.push(smartFormCategory);
      }

      // Find the smartFormSubcategory within the smartFormCategory
      let smartFormSubcategory = smartFormCategory.smartFormSubCategories.find(s => s.id == subCategory.id);
      if (!smartFormSubcategory) {
          // If the smartFormSubcategory doesn't exist, create it
          smartFormSubcategory = {
              id: subCategory.id,
              smartFormQuestions: []
          };
          smartFormCategory.smartFormSubCategories.push(smartFormSubcategory);
      }

      // Add the updated question to the smartFormSubcategory
      const updatedQuestionData = {
        id: question.id,
        smartFormSubCategoryId: question.smartFormSubCategoryId,
        order: question.order,
        showByDefault: question.showByDefault,
        hideForPreparer: question.hideForPreparer,
        triggerSyncInOneTeam: question.triggerSyncInOneTeam,
      }
      smartFormSubcategory.smartFormQuestions.push(updatedQuestionData);
      deletedItems.questions = deletedItems.questions.filter(q => q.id !== question.id);
    }

    // get all newly created items
    this.categories.forEach((category, i) => {
      let newCategory = {
        name: category.name,
        order: i+1,
        year: this.taxYear,
        smartFormTypeId: this.smartFormTypeId,
        smartFormSubCategories: []
      }
      let isNewCategory = category.id == undefined;
      category.smartFormSubCategories.forEach((subCategory, j) => {
        let newSubCategory: any = {
          name: subCategory.name,
          order: j+1,
          smartFormQuestions: []
        }
        let isNewSubCategory = isNewCategory || subCategory.id == undefined;
        subCategory.smartFormQuestions.forEach((question: any, k) => {
          if (question.id == undefined) {
            const newQuestion: any = {
              order: k+1,
              year: this.taxYear,
              questionId: question.questionId,
              showByDefault: question.showByDefault,
              hideForPreparer: question.hideForPreparer,
              triggerSyncInOneTeam: question.triggerSyncInOneTeam
            }
            if (isNewSubCategory) {
              newSubCategory.smartFormQuestions.push(newQuestion);
            }
            else {
              newQuestion.smartFormSubCategoryId = subCategory.id;
              createdItems.questions.push(newQuestion);
            }
          }else {
            if (question?.oldSmartFormSubCategoryId && question?.oldSmartFormSubCategoryId !== subCategory.id) {
              question.order = k + 1
              addQuestionAsUpdatedItem(category, subCategory, question)
            }
          }
        });
        if (isNewCategory) {
          newCategory.smartFormSubCategories.push(newSubCategory)
        }
        else if (isNewSubCategory) {
          newSubCategory.smartFormCategoryId = category.id;
          createdItems.subCategories.push(newSubCategory)
        }
      });

      if (isNewCategory) {
        createdItems.categories.push(newCategory)
      }
    })

    const data = {
      updatedSmartForm,
      deletedItems,
      createdItems
    }
    this.rootLogicNodes.forEach(node => node.smartFormTypeId = this.smartFormTypeId);
    this.isSaving = true;
    this.smartFormService.saveFullSmartFormTypeData(data).subscribe(result => {
      if(this.rootLogicNodes.length > 0 || this.deletedLogicNodes.length > 0) {
        this.smartFormLogicService.updateSmartFormLogic({ smartFormLogicList: this.rootLogicNodes, smartFormLogicDeleteList: this.deletedLogicNodes.map(val => val.id)  }).subscribe(res => {
          this.deletedLogicNodes = [];
          this.isSaving = false;
          this.isLoading = true;
          this.loadSmartFormData(this.taxYear, this.smartFormTypeId);
        })
      }
      else {
        this.isSaving = false;
        this.isLoading = true;
        this.loadSmartFormData(this.taxYear, this.smartFormTypeId);
      }

    })
  }


}
